import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import KitInput from '../../UI/KitInput';
import {
  additionalOptionsArray,
  perplexityOptions,
  systemDisplayNameMap,
  systemValueMap,
} from '../../AiConfigs/constants';
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormSetValue,
  WatchInternal,
} from 'react-hook-form';

interface Props {
  errors: FieldErrors<any>;
  register: UseFormRegister<any>;
  systemType: string;
  setSystemType: React.Dispatch<React.SetStateAction<string>>;
  watch: WatchInternal<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  systems: any[]
}

const PerplexityConfigForm = ({
  errors,
  register,
  setSystemType,
  setValue,
  systemType,
  control,
  watch,
  systems,
}: Props) => {
  return (
    <Box>
      {/* <KitInput
        label='Name'
        name='name'
        type='text'
        errorsStatus={errors}
        register={register}
      /> */}
      <Box
        mt={'16px'}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '32px',
        }}
      >
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label" title="Ai System">
            Ai System
          </InputLabel>
          <Select
            name="AiSystem"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Ai System"
            value={systemType}
            onChange={e => {
              setSystemType(e.target.value);
            }}
            sx={{
              width: '100%',
            }}
          >
            {systems?.map((opt, index) => {
              const disabled = opt.models?.every(
                (model: any) => model.disabledByCompany,
              );
              const systemValue = systemValueMap[opt.system] || opt.system;
              const displayName =
                systemDisplayNameMap[systemValue] || systemValue;
              return (
                <MenuItem
                  key={index}
                  value={systemValue}
                  disabled={disabled}
                >
                  {displayName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Type</InputLabel>
          <Select
            value={watch().perplexityType}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Type"
            {...register('perplexityType')}
            sx={{
              width: '100%',
            }}
          >
            {systems.length > 0
              ? systems
                  .filter((item: any) => item.system === 'perplexity')[0]
                  .models?.map((opt: any) => (
                    <MenuItem
                      key={opt.id}
                      value={opt.model}
                      disabled={opt.disabledByCompany}
                    >
                      {opt.model}
                    </MenuItem>
                  ))
              : perplexityOptions.map(opt => (
                  <MenuItem key={opt} value={opt}>
                    {opt}
                  </MenuItem>
                ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default PerplexityConfigForm;
